 /**
 * 角色权限处理
 * Copyright (c) 2019 wmc
 */

import store from '@/store'

export default {
  inserted(el, binding, vnode) {
    const { value } = binding
    const super_admin = "SA";
    const roles = store.getters && store.getters["user/getUserInfo"] && store.getters["user/getUserInfo"].role
    // console.log('roles', roles)
    if (value && value instanceof Array && value.length > 0) {
      const roleFlag = value

      const hasRole = roleFlag.some(role => {
        return super_admin === role || role == roles
      })

      if (!hasRole) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`请设置角色权限标签值"`)
    }
  }
}
